import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  activeSimulator: ['user', 'userSimulated', 'firstNameUserSimulated'],
  inactiveSimulator: null,
  simulatorWarningOn: null,
  simulatorWarningOff: null
});

export { Creators, Types };
